// JsFromRoutes CacheKey 0e393f3b1486ad281dea9c31b2fa37ad
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const maintenance = {
  list: definePathHelper("get", "/maintenance_requests"),
  create: definePathHelper("post", "/maintenance_requests"),
};
